// extracted by mini-css-extract-plugin
module.exports = {"tableOfContentContainer":"_2e1d24","trustBannerContainer":"_7cc880","pageContainer":"_0400fc","bodyContainer":"_ee0f07"};